import LevelsPage from './LevelsPage';

export default LevelsPage;
